var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { chain } from 'lodash';
import { classToPlain } from 'class-transformer';
import { HttpBody } from './HttpBody';
import { Model } from './Model';
import { $, apiFullURL } from '../../helpers';
var Resource = /** @class */ (function (_super) {
    __extends(Resource, _super);
    function Resource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Resource.prototype, "$schema", {
        /**
         * Normalizes what will be showed as entity or list
         */
        get: function () {
            var json = JSON.stringify(this);
            var data = JSON.parse(json);
            delete data.$endpoint;
            delete data.$name;
            return data;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "$tag", {
        /**
         * Tag of entity
         */
        get: function () {
            return this.$id.toString();
        },
        set: function (val) {
            /**/
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "fieldsToRender", {
        /**
         * Get render fields from schema
         */
        get: function () {
            return (chain(this.$schema)
                // Hide hidden properties
                .pickBy(function (val) { return (val ? val.hidden !== true : true); })
                // Get the keys value
                .keys()
                // Get the result
                .value());
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Resource.prototype, "fieldsToInput", {
        /**
         * Get input fields from schema
         */
        get: function () {
            return (chain(this.$schema)
                // Hide undefined inputType properties
                .pickBy(function (val) { return val && val.input !== undefined; })
                // Get the keys value
                .keys()
                // Get the result
                .value());
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Transform schema into data
     * @param field Get the content of a given field. If it is not set then get the content of all fields
     * @param index Used to select the index of the content if it is an array
     * @param textContent If true then use the text format instead the component as content
     */
    Resource.prototype.renderSchema = function (_a) {
        var _b = _a === void 0 ? {} : _a, field = _b.field, _c = _b.index, index = _c === void 0 ? 0 : _c, _d = _b.asText, asText = _d === void 0 ? false : _d;
        var filterContent = function (val) {
            return val ? val.hidden !== true : true;
        };
        var filterTextContent = function (val) {
            return asText ? !!(val && val.textContent !== null) : true;
        };
        var getContent = function (val) {
            var preContent = val && val.content;
            // get content from textContent if it is set
            if (asText)
                preContent = val && (val.textContent || val.content);
            var content = (preContent || val);
            // if the content is an array then get the item from index (default is the first)
            if (content instanceof Array)
                content = content[index];
            return content;
        };
        var validateContent = function (val) {
            return typeof val === 'object' && !(val && val.component) ? '' : val;
        };
        var filteredContent = function (val) { return filterContent(val) && filterTextContent(val); };
        var mappedContent = function (val) { return validateContent(getContent(val)); };
        // if the field is set then return the schema content
        if (field) {
            var schemaVal = this.$schema[field];
            if (filteredContent(schemaVal)) {
                return mappedContent(schemaVal);
            }
            return null;
        }
        // otherwise return the schema data
        return (chain(this.$schema)
            // Hide hidden properties and null textContent
            .pickBy(filteredContent)
            // Map the schema to get only the content and transform invalid content into empty string
            .mapValues(mappedContent)
            // Get the result
            .value());
    };
    /**
     * Finds and return a entity from WebServer
     * @param id entity ID
     * @param spinner
     */
    Resource.prototype.find = function (id, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.call($.resource(apiFullURL(this.$endpoint)).get({ id: id }))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "find" + this.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Finds and return a entity from WebServer by query
     * @param query
     * @param spinner
     */
    Resource.prototype.findByQuery = function (query, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.call($.resource(apiFullURL(this.$endpoint)).get(query))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "find" + this.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Saves this entity and post it into WebServer
     * @param cls
     * @param spinner
     */
    Resource.prototype.save = function (cls, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var body, fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = classToPlain(this);
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, new HttpBody(cls).call($.resource(apiFullURL(this.$endpoint)).save(body))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "save" + this.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates this entity and post it into WebServer
     * @param cls
     * @param spinner
     */
    Resource.prototype.update = function (cls, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var body, fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        body = classToPlain(this);
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, new HttpBody(cls).call($.resource(apiFullURL(this.$endpoint)).update(body))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "update" + this.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Removes a entity from WebServer
     * @param cls
     * @param spinner
     */
    Resource.prototype.remove = function (cls, spinner) {
        return __awaiter(this, void 0, void 0, function () {
            var fetch;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fetch = function () { return __awaiter(_this, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, new HttpBody(cls).call($.resource(apiFullURL(this.$endpoint)).remove({ id: this.$id }))];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); };
                        return [4 /*yield*/, $.await.run(fetch, spinner || "remove" + this.$name)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate and save
     */
    Resource.prototype.validateAndSave = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validate()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.save()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Validate and update
     */
    Resource.prototype.validateAndUpdate = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.validate()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.update()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return Resource;
}(Model));
export { Resource };
//# sourceMappingURL=Resource.js.map